// Real data migrated from toolsmetric.com

export const categories = [
  {
    id: 1,
    name: "Marketing Automation",
    slug: "marketing-automation",
    description: "Automate your marketing workflows and campaigns to drive growth",
    icon: "Megaphone",
    toolCount: 45,
    color: "from-pink-500 to-rose-500",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&h=250&fit=crop"
  },
  {
    id: 2,
    name: "Customer Relationship Management",
    slug: "crm-software",
    description: "Manage customer relationships effectively with powerful CRM tools",
    icon: "Users",
    toolCount: 38,
    color: "from-blue-500 to-indigo-500",
    image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=250&fit=crop"
  },
  {
    id: 3,
    name: "Financial Reporting",
    slug: "financial-reporting",
    description: "Generate accurate financial reports and insights for your business",
    icon: "DollarSign",
    toolCount: 28,
    color: "from-green-500 to-emerald-500",
    image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=400&h=250&fit=crop"
  },
  {
    id: 4,
    name: "ERP",
    slug: "erp-software",
    description: "Enterprise resource planning solutions for streamlined operations",
    icon: "Building2",
    toolCount: 32,
    color: "from-purple-500 to-violet-500",
    image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=400&h=250&fit=crop"
  },
  {
    id: 5,
    name: "E-Mail Marketing",
    slug: "email-marketing",
    description: "Create and manage powerful email campaigns that convert",
    icon: "Mail",
    toolCount: 29,
    color: "from-amber-500 to-orange-500",
    image: "https://images.unsplash.com/photo-1596526131083-e8c633c948d2?w=400&h=250&fit=crop"
  },
  {
    id: 6,
    name: "Human Resource Management",
    slug: "hr-software",
    description: "Streamline your HR operations with modern HR management tools",
    icon: "UserCog",
    toolCount: 34,
    color: "from-cyan-500 to-blue-500",
    image: "https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=400&h=250&fit=crop"
  },
  {
    id: 7,
    name: "SEO",
    slug: "seo-tools",
    description: "Optimize your search engine visibility and drive organic traffic",
    icon: "Search",
    toolCount: 41,
    color: "from-teal-500 to-green-500",
    image: "https://images.unsplash.com/photo-1432888498266-38ffec3eaf0a?w=400&h=250&fit=crop"
  },
  {
    id: 8,
    name: "Artificial Intelligence",
    slug: "artificial-intelligence",
    description: "Leverage AI-powered tools to enhance productivity and innovation",
    icon: "Brain",
    toolCount: 67,
    color: "from-indigo-500 to-purple-500",
    image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=400&h=250&fit=crop"
  },
  {
    id: 9,
    name: "Project Management",
    slug: "project-management",
    description: "Plan, track, and deliver projects on time with the best PM tools",
    icon: "Kanban",
    toolCount: 52,
    color: "from-emerald-500 to-teal-500",
    image: "https://images.unsplash.com/photo-1611224923853-80b023f02d71?w=400&h=250&fit=crop"
  },
  {
    id: 10,
    name: "Analytics & BI",
    slug: "analytics-bi",
    description: "Make data-driven business decisions with powerful analytics",
    icon: "BarChart3",
    toolCount: 36,
    color: "from-slate-500 to-gray-600",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&h=250&fit=crop"
  }
];

export const tools = [
  // Financial & ERP Tools
  {
    id: 1,
    name: "Workday Financial Management",
    slug: "workday-financial-management",
    logo: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=100&h=100&fit=crop",
    website: "https://www.workday.com/en-us/products/financial-management/overview.html",
    description: "Workday Financials is a financial reporting software built on an adaptive, global foundation that helps organizations plan, execute, and analyze their finances in real-time.",
    category: "Financial Reporting",
    categorySlug: "financial-reporting",
    pricing: "Custom Pricing",
    priceType: "custom",
    rating: 10,
    reviews: 856,
    features: ["Financial Planning", "Real-time Reporting", "Global Support", "Analytics Dashboard"],
    trending: true,
    verified: true
  },
  {
    id: 2,
    name: "ERPNext",
    slug: "erpnext",
    logo: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=100&h=100&fit=crop",
    website: "https://erpnext.com/pricing",
    description: "ERPNext is an open-source enterprise resource planning software. It is a web-based platform aimed at small and medium-sized businesses with comprehensive modules.",
    category: "ERP",
    categorySlug: "erp-software",
    pricing: "from $1.25/week",
    priceType: "paid",
    rating: 10,
    reviews: 1234,
    features: ["Accounting", "Inventory", "HR Management", "CRM", "Manufacturing"],
    trending: true,
    verified: true
  },
  // Email Marketing Tools
  {
    id: 3,
    name: "Zoho Campaigns",
    slug: "zoho-campaigns",
    logo: "https://images.unsplash.com/photo-1596526131083-e8c633c948d2?w=100&h=100&fit=crop",
    website: "https://www.zoho.com/campaigns/signup.html",
    description: "Zoho Campaigns is a cloud-based email marketing solution designed to build, deliver, and track email campaigns with powerful automation features.",
    category: "E-Mail Marketing",
    categorySlug: "email-marketing",
    pricing: "from $6/month",
    priceType: "freemium",
    rating: 10,
    reviews: 2156,
    features: ["Email Automation", "A/B Testing", "Analytics", "Templates", "List Management"],
    trending: true,
    verified: true
  },
  {
    id: 4,
    name: "FreshMail",
    slug: "freshmail",
    logo: "https://images.unsplash.com/photo-1563986768494-4dee2763ff3f?w=100&h=100&fit=crop",
    website: "https://freshmail.com/pricing/",
    description: "With FreshMail, users can create newsletters and track and send messages to their customers with beautiful templates and powerful tracking.",
    category: "E-Mail Marketing",
    categorySlug: "email-marketing",
    pricing: "from $14/month",
    priceType: "paid",
    rating: 10,
    reviews: 987,
    features: ["Newsletter Builder", "Tracking", "Templates", "Automation"],
    trending: false,
    verified: true
  },
  {
    id: 5,
    name: "Sender",
    slug: "sender",
    logo: "https://images.unsplash.com/photo-1557200134-90327ee9fafa?w=100&h=100&fit=crop",
    website: "https://www.sender.net/",
    description: "Sender is one of the best cloud-based email marketing platforms designed to help businesses of all sizes create and manage email campaigns.",
    category: "E-Mail Marketing",
    categorySlug: "email-marketing",
    pricing: "from $11/month",
    priceType: "freemium",
    rating: 9.5,
    reviews: 1567,
    features: ["Drag & Drop Editor", "Automation", "Analytics", "Free Plan Available"],
    trending: true,
    verified: true
  },
  // HR Tools
  {
    id: 6,
    name: "ADP WorkforceNow",
    slug: "adp-workforce",
    logo: "https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=100&h=100&fit=crop",
    website: "https://www.adp.com/",
    description: "ADP Workforce Now is a web-based human resources application designed for medium to large businesses with comprehensive payroll and HR features.",
    category: "Human Resource Management",
    categorySlug: "hr-software",
    pricing: "Custom Pricing",
    priceType: "custom",
    rating: 10,
    reviews: 3421,
    features: ["Payroll", "Benefits Admin", "Time Tracking", "Talent Management"],
    trending: true,
    verified: true
  },
  {
    id: 7,
    name: "BambooHR",
    slug: "bamboohr",
    logo: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=100&h=100&fit=crop",
    website: "https://www.bamboohr.com/",
    description: "BambooHR is a cloud-based HR software used for human resource services, most effective for small and medium-sized businesses.",
    category: "Human Resource Management",
    categorySlug: "hr-software",
    pricing: "Custom Pricing",
    priceType: "custom",
    rating: 9.5,
    reviews: 2876,
    features: ["Employee Database", "Time Off Management", "Reporting", "Onboarding"],
    trending: true,
    verified: true
  },
  {
    id: 8,
    name: "KekaHR",
    slug: "kekahr",
    logo: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=100&h=100&fit=crop",
    website: "https://www.keka.com/",
    description: "KekaHR is a modern HR and payroll software designed to simplify complex HR processes with automation and analytics.",
    category: "Human Resource Management",
    categorySlug: "hr-software",
    pricing: "from $16/month",
    priceType: "paid",
    rating: 9.5,
    reviews: 1234,
    features: ["Payroll", "Leave Management", "Performance Reviews", "Attendance"],
    trending: true,
    verified: true
  },
  {
    id: 9,
    name: "SmartRecruiter",
    slug: "smartrecruiter",
    logo: "https://images.unsplash.com/photo-1573497019236-17f8177b81e8?w=100&h=100&fit=crop",
    website: "https://www.smartrecruiters.com/",
    description: "SmartRecruiter is a web-based recruitment tool designed for modern talent acquisition with AI-powered candidate matching.",
    category: "Human Resource Management",
    categorySlug: "hr-software",
    pricing: "Custom Pricing",
    priceType: "custom",
    rating: 9.5,
    reviews: 1987,
    features: ["ATS", "Candidate Sourcing", "Interview Scheduling", "Analytics"],
    trending: false,
    verified: true
  },
  {
    id: 10,
    name: "Workable",
    slug: "workable",
    logo: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=100&h=100&fit=crop",
    website: "https://www.workable.com/",
    description: "Workable is a comprehensive recruiting software that helps companies find, evaluate, and hire the best candidates faster.",
    category: "Human Resource Management",
    categorySlug: "hr-software",
    pricing: "from $99/month",
    priceType: "paid",
    rating: 9.4,
    reviews: 1654,
    features: ["Job Posting", "Applicant Tracking", "AI Recruiter", "Assessments"],
    trending: false,
    verified: true
  },
  {
    id: 11,
    name: "Breezy HR",
    slug: "breezy-hr",
    logo: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=100&h=100&fit=crop",
    website: "https://breezy.hr/",
    description: "Breezy HR is an end-to-end recruiting software that helps attract and hire great employees with less effort.",
    category: "Human Resource Management",
    categorySlug: "hr-software",
    pricing: "from $171/month",
    priceType: "paid",
    rating: 9.3,
    reviews: 1234,
    features: ["Pipeline Management", "Automated Tasks", "Video Interviews", "Scorecards"],
    trending: false,
    verified: true
  },
  // CRM Tools
  {
    id: 12,
    name: "HubSpot CRM",
    slug: "hubspot-crm",
    logo: "https://images.unsplash.com/photo-1611162617474-5b21e879e113?w=100&h=100&fit=crop",
    website: "http://hubs.to/tgNvd",
    description: "HubSpot CRM is ideal for companies with 10-1,000 employees. This platform is easy-to-use and offers comprehensive sales, marketing, and service tools.",
    category: "Customer Relationship Management",
    categorySlug: "crm-software",
    pricing: "from $50/month",
    priceType: "freemium",
    rating: 9.5,
    reviews: 4521,
    features: ["Contact Management", "Email Marketing", "Sales Pipeline", "Reporting"],
    trending: true,
    verified: true
  },
  {
    id: 13,
    name: "Workbooks CRM",
    slug: "workbooks-crm",
    logo: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=100&h=100&fit=crop",
    website: "https://www.workbooks.com/try-now/",
    description: "Workbooks CRM is a software app that helps sales leaders, salespeople, and marketers manage their customer relationships effectively.",
    category: "Customer Relationship Management",
    categorySlug: "crm-software",
    pricing: "from $30/user/month",
    priceType: "paid",
    rating: 9.5,
    reviews: 876,
    features: ["Sales Automation", "Marketing Automation", "Customer Service", "Reporting"],
    trending: false,
    verified: true
  },
  {
    id: 14,
    name: "Nutshell CRM",
    slug: "nutshell-crm",
    logo: "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=100&h=100&fit=crop",
    website: "https://www.nutshell.com/pricing/",
    description: "Nutshell CRM gives teams the tools and features they require to convert leads into customers with powerful automation.",
    category: "Customer Relationship Management",
    categorySlug: "crm-software",
    pricing: "from $19/month",
    priceType: "paid",
    rating: 9.5,
    reviews: 1234,
    features: ["Contact Management", "Sales Automation", "Reporting", "Email Sequences"],
    trending: false,
    verified: true
  },
  {
    id: 15,
    name: "Apptivo CRM",
    slug: "apptivo-crm",
    logo: "https://images.unsplash.com/photo-1551434678-e076c223a692?w=100&h=100&fit=crop",
    website: "https://www.apptivo.com/",
    description: "Apptivo CRM is one of the most robust tools that allow you to manage your marketing, sales, and customer service in one platform.",
    category: "Customer Relationship Management",
    categorySlug: "crm-software",
    pricing: "from $8/month",
    priceType: "paid",
    rating: 9.4,
    reviews: 987,
    features: ["Lead Management", "Project Management", "Invoicing", "Help Desk"],
    trending: false,
    verified: true
  },
  {
    id: 16,
    name: "PipelineDeals",
    slug: "pipelinedeals",
    logo: "https://images.unsplash.com/photo-1556761175-b413da4baf72?w=100&h=100&fit=crop",
    website: "https://www.pipelinedeals.com/",
    description: "PipelineDeals is a sales CRM designed to help sales teams close more deals with intuitive pipeline management.",
    category: "Customer Relationship Management",
    categorySlug: "crm-software",
    pricing: "from $25/month",
    priceType: "paid",
    rating: 9.3,
    reviews: 765,
    features: ["Pipeline Management", "Email Tracking", "Reporting", "Integrations"],
    trending: false,
    verified: true
  },
  {
    id: 17,
    name: "Really Simple Systems CRM",
    slug: "really-simple-systems-crm",
    logo: "https://images.unsplash.com/photo-1553877522-43269d4ea984?w=100&h=100&fit=crop",
    website: "http://www.reallysimplesystems.com/",
    description: "Really Simple Systems CRM enables small and medium-sized B2B organizations to manage their sales and customer relationships.",
    category: "Customer Relationship Management",
    categorySlug: "crm-software",
    pricing: "from $14/month",
    priceType: "freemium",
    rating: 9.3,
    reviews: 654,
    features: ["Contact Management", "Sales Pipeline", "Marketing", "Service & Support"],
    trending: false,
    verified: true
  },
  // SEO Tools
  {
    id: 18,
    name: "SE Ranking",
    slug: "se-ranking",
    logo: "https://images.unsplash.com/photo-1432888498266-38ffec3eaf0a?w=100&h=100&fit=crop",
    website: "https://seranking.com/",
    description: "SE Ranking is a comprehensive SEO platform for keyword research, competitor analysis, site audit, and rank tracking.",
    category: "SEO",
    categorySlug: "seo-tools",
    pricing: "from $39/month",
    priceType: "paid",
    rating: 9.5,
    reviews: 2134,
    features: ["Rank Tracking", "Keyword Research", "Site Audit", "Competitor Analysis"],
    trending: true,
    verified: true
  },
  // Marketing Automation
  {
    id: 19,
    name: "LeadSquared",
    slug: "leadsquared",
    logo: "https://images.unsplash.com/photo-1557200134-90327ee9fafa?w=100&h=100&fit=crop",
    website: "https://www.leadsquared.com/",
    description: "LeadSquared is a marketing automation platform suitable for all business sizes, from real-estate to education and healthcare.",
    category: "Marketing Automation",
    categorySlug: "marketing-automation",
    pricing: "from $150/month",
    priceType: "paid",
    rating: 9.5,
    reviews: 1876,
    features: ["Lead Capture", "Lead Scoring", "Sales Automation", "Analytics"],
    trending: true,
    verified: true
  },
  {
    id: 20,
    name: "ExactTarget (Salesforce Marketing Cloud)",
    slug: "exacttarget",
    logo: "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=100&h=100&fit=crop",
    website: "https://www.salesforce.com/products/marketing-cloud/overview/",
    description: "ExactTarget is designed to help businesses build and manage customer relationships and their journeys across all channels.",
    category: "Marketing Automation",
    categorySlug: "marketing-automation",
    pricing: "Custom Pricing",
    priceType: "custom",
    rating: 10,
    reviews: 3421,
    features: ["Email Studio", "Journey Builder", "Mobile Studio", "Social Studio"],
    trending: false,
    verified: true
  },
  // AI Tools
  {
    id: 21,
    name: "ActiveLense",
    slug: "activelense",
    logo: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=100&h=100&fit=crop",
    website: "https://activelense.com/",
    description: "ActiveLense is an employee monitoring and productivity tool that uses AI to enhance workplace efficiency.",
    category: "Artificial Intelligence",
    categorySlug: "artificial-intelligence",
    pricing: "from $0.6/month",
    priceType: "paid",
    rating: 9.5,
    reviews: 567,
    features: ["Time Tracking", "Screenshot Capture", "Productivity Reports", "App Monitoring"],
    trending: true,
    verified: true
  },
  {
    id: 22,
    name: "Swipe Pages",
    slug: "swipe-pages",
    logo: "https://images.unsplash.com/photo-1611162618071-b39a2ec055fb?w=100&h=100&fit=crop",
    website: "https://swipepages.com/",
    description: "Swipe Pages is an AI-powered landing page builder designed for marketers to create high-converting pages quickly.",
    category: "Artificial Intelligence",
    categorySlug: "artificial-intelligence",
    pricing: "from $29/month",
    priceType: "paid",
    rating: 9.3,
    reviews: 432,
    features: ["Drag & Drop Builder", "A/B Testing", "AMP Pages", "Integrations"],
    trending: true,
    verified: true
  },
  // Financial Tools
  {
    id: 23,
    name: "Wave",
    slug: "wave",
    logo: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=100&h=100&fit=crop",
    website: "https://www.waveapps.com/",
    description: "Wave is a free financial software for small businesses, offering accounting, invoicing, and receipt scanning.",
    category: "Financial Reporting",
    categorySlug: "financial-reporting",
    pricing: "Free",
    priceType: "free",
    rating: 9.3,
    reviews: 4567,
    features: ["Accounting", "Invoicing", "Receipt Scanning", "Payroll"],
    trending: true,
    verified: true
  }
];

export const blogs = [
  {
    id: 1,
    title: "AI-Powered IT Security Tools: How Real-Time Threat Detection is Redefining Enterprise Protection",
    slug: "ai-powered-it-security-tools-2025",
    excerpt: "In 2025, enterprise IT security is more complex and critical than ever. Traditional, rule-based security tools are often reactive. Today, AI-powered security platforms are changing the game by providing real-time threat detection.",
    image: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=800&h=450&fit=crop",
    category: "AI & Technology",
    author: "Vansh Banthia",
    authorAvatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop",
    date: "Dec 26, 2025",
    readTime: "8 min read"
  },
  {
    id: 2,
    title: "Underrated Real-Time AI Tools Quietly Driving Highly Qualified B2B Leads",
    slug: "underrated-ai-tools-b2b-leads",
    excerpt: "AI has fundamentally changed how B2B teams approach lead generation—but the biggest gains aren't coming from the most talked-about platforms. A quieter category of real-time AI tools is transforming sales.",
    image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&h=450&fit=crop",
    category: "AI & Technology",
    author: "Vansh Banthia",
    authorAvatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop",
    date: "Dec 26, 2025",
    readTime: "6 min read"
  },
  {
    id: 3,
    title: "Underrated Real-Time AI Tools Quietly Automating Critical Business Workflows",
    slug: "ai-tools-automating-workflows",
    excerpt: "AI isn't only transforming sales and marketing. Some of the most impactful innovations are happening inside operations, finance, product, and customer support teams.",
    image: "https://images.unsplash.com/photo-1485827404703-89b55fcc595e?w=800&h=450&fit=crop",
    category: "Productivity",
    author: "Vansh Banthia",
    authorAvatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop",
    date: "Dec 26, 2025",
    readTime: "7 min read"
  },
  {
    id: 4,
    title: "Top 10 Tool Management Metrics Every Production Manager Should Track",
    slug: "tool-management-metrics-production",
    excerpt: "In modern manufacturing, efficiency is no longer driven only by machines or materials—it's driven by data. For production managers, tool management is a high-impact area for data-driven improvement.",
    image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&h=450&fit=crop",
    category: "Management",
    author: "Vansh Banthia",
    authorAvatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop",
    date: "Dec 26, 2025",
    readTime: "10 min read"
  },
  {
    id: 5,
    title: "What You Don't Know About B2B Tools Is Slowing Your Team Down",
    slug: "b2b-tools-slowing-team-down",
    excerpt: "Most teams don't struggle because they lack tools. They struggle because they don't fully understand the tools they already have access to—or the smarter alternatives they haven't discovered yet.",
    image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&h=450&fit=crop",
    category: "Productivity",
    author: "Vansh Banthia",
    authorAvatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop",
    date: "Dec 23, 2025",
    readTime: "5 min read"
  },
  {
    id: 6,
    title: "Discovering Marketing Tools Built to Fix Specific Operational Gaps",
    slug: "marketing-tools-operational-gaps",
    excerpt: "Marketing teams don't struggle because they lack creativity or strategy. They struggle because operational friction slows everything down. Campaigns get delayed, data lives in silos.",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=450&fit=crop",
    category: "Marketing",
    author: "Vansh Banthia",
    authorAvatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop",
    date: "Dec 23, 2025",
    readTime: "6 min read"
  },
  {
    id: 7,
    title: "Discovering Niche Tools That Solve Specific Problems for Sales Teams",
    slug: "niche-tools-sales-teams",
    excerpt: "Sales teams don't fail because they lack effort, motivation, or ambition. They fail because they rely on generic tools to solve highly specific problems.",
    image: "https://images.unsplash.com/photo-1556761175-b413da4baf72?w=800&h=450&fit=crop",
    category: "Sales",
    author: "Vansh Banthia",
    authorAvatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop",
    date: "Dec 23, 2025",
    readTime: "7 min read"
  },
  {
    id: 8,
    title: "The Intelligence Layer: Top Real-Time Decision Support AI Tools Transforming B2B Operations",
    slug: "intelligence-layer-ai-tools-b2b",
    excerpt: "In the modern B2B landscape, the speed of business has outpaced the speed of the boardroom. Real-time decision support AI tools are transforming how businesses operate.",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=450&fit=crop",
    category: "AI & Technology",
    author: "Vansh Banthia",
    authorAvatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop",
    date: "Dec 19, 2025",
    readTime: "9 min read"
  },
  {
    id: 9,
    title: "Navigating the B2B Tech Jungle: The Ultimate Guide to Tool Discovery",
    slug: "b2b-tech-jungle-tool-discovery",
    excerpt: "In the modern business landscape, the 'SaaS-ification' of every department is no longer a trend—it is a reality. The average company now uses over 100 different software applications.",
    image: "https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=800&h=450&fit=crop",
    category: "Business",
    author: "Vansh Banthia",
    authorAvatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop",
    date: "Dec 19, 2025",
    readTime: "8 min read"
  },
  {
    id: 10,
    title: "How Businesses Can Discover the Right Tools Without Getting Lost in the SaaS Overload",
    slug: "discover-right-tools-saas-overload",
    excerpt: "The modern software ecosystem is growing at an unprecedented pace. While this explosion of innovation is exciting, it has created a serious challenge: tool fatigue.",
    image: "https://images.unsplash.com/photo-1553877522-43269d4ea984?w=800&h=450&fit=crop",
    category: "Business",
    author: "Vansh Banthia",
    authorAvatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop",
    date: "Dec 23, 2025",
    readTime: "6 min read"
  }
];

export const stats = [
  { label: "Tools Listed", value: "2,500+" },
  { label: "Categories", value: "50+" },
  { label: "User Reviews", value: "45K+" },
  { label: "Monthly Visitors", value: "150K+" }
];

export const testimonials = [
  {
    id: 1,
    name: "Jennifer Martinez",
    role: "Marketing Director",
    company: "TechFlow Inc.",
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop",
    content: "ToolsMetric helped us find the perfect marketing automation tool. The comparison feature saved us weeks of research!",
    rating: 5
  },
  {
    id: 2,
    name: "Robert Chen",
    role: "Startup Founder",
    company: "InnovateLab",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop",
    content: "As a startup founder, every tool decision matters. This platform made it easy to compare pricing and features side by side.",
    rating: 5
  },
  {
    id: 3,
    name: "Amanda Foster",
    role: "Operations Manager",
    company: "ScaleUp Corp",
    avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop",
    content: "The honest reviews from real users helped us avoid tools that wouldn't fit our workflow. Highly recommend!",
    rating: 5
  }
];

// Popular search tags for the homepage
export const popularTags = [
  "CRM",
  "Project Management", 
  "AI Tools",
  "Email Marketing",
  "SEO",
  "HR Software",
  "ERP",
  "Financial Reporting"
];

// Feature highlights for homepage
export const features = [
  {
    title: "Compare Tools",
    description: "Confused between two software? Select your favorite tools to compare features, price, and reviews to make an informed decision.",
    icon: "GitCompare"
  },
  {
    title: "Read Real Reviews",
    description: "Don't believe in false and biased promotions. Read real reviews and make a decision based on experiences shared by real users.",
    icon: "MessageSquare"
  },
  {
    title: "Expert Guides",
    description: "If you are not sure which tools your business could benefit from, read our in-depth buying guides and articles that can help!",
    icon: "BookOpen"
  }
];
